import { render } from "./TechnologiesView.vue?vue&type=template&id=2127bdb6&ts=true"
import script from "./TechnologiesView.vue?vue&type=script&lang=ts"
export * from "./TechnologiesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__